module.exports = __webpack_public_path__ + "assets/img/hov_btn_pc-e43e80fb.png";